import React from "react";
import chroma from "chroma-js";

const thStylePrint = {
  fontSize: "1.2rem",
  fontWeight: "400",
  textAlign: "center",
  border: "1px solid #c3c3c3",
};

const tdStylePrint = {
  fontSize: "1.0rem",
  fontWeight: "800",
  verticalAlign: "middle",
  textAlign: "center",
  border: "1px solid #c3c3c3",
};

const tdStylePrintReview = {
  fontSize: "1.0rem",
  fontWeight: "400",
  verticalAlign: "middle",
  textAlign: "center",
  border: "1px solid #c3c3c3",
};

const tableStyle = {
  width: "100%",
  height: "100px",
  fontSize: "12px",
  marginTop: "30px",
  borderCollapse: "collapse",
  border: "1px solid #c3c3c3",
};

const scale = chroma.scale(["red", "orange", "lightgreen"]).domain([0, 2.5, 5]);

const PrintDiv = ({
  locationAddress,
  stopCity,
  stopState,
  stopCountry,
  stopZip,
  locationName,
  headerArrayElement,
  ratings,
  driverCommentList
}) => {
  const addressText = [locationAddress, stopCity, stopState, stopCountry, stopZip]
    .filter(Boolean)
    .join(", ");

  return (
    <div id="print-div">
      <div style={{ width: "100%" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <div style={{ fontSize: "20px" }}>{locationName}</div>
            <div style={{ fontSize: "15px" }}>{addressText}</div>
          </div>
        </div>

        {/* Ratings Table */}
        <table style={tableStyle}>
          <thead>
            <tr>
              {headerArrayElement.map((item, index) => (
                <th key={index} style={thStylePrint}>
                  {item}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              {ratings.map((item, index) => (
                <td
                  key={index}
                  style={{
                    ...tdStylePrint,
                    backgroundColor: scale(item).hex(),
                  }}
                >
                  {item}
                </td>
              ))}
            </tr>
          </tbody>
        </table>

        {/* Driver Comments Table */}
        <table style={tableStyle}>
          <thead>
            <tr>
              <th style={thStylePrint}>Date</th>
              <th style={thStylePrint}>Driver 1</th>
              <th style={thStylePrint}>Driver 2</th>
              <th style={thStylePrint}>Comment</th>
            </tr>
          </thead>
          <tbody style={{ width: "100%" }}>
            {driverCommentList.map((item, index) => (
              <tr key={index}>
                <td style={tdStylePrintReview}>{item.createdAt}</td>
                <td style={tdStylePrintReview}>{item.driver1_name}</td>
                <td style={tdStylePrintReview}>{item.driver2_name}</td>
                <td style={tdStylePrintReview}>{item.comment}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PrintDiv;
